import { ViewportScroller } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { catchError, debounceTime, distinctUntilChanged, of, Subject, Subscription, switchMap } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from 'src/app/core/services/auth.service';
import { AppProfile } from 'src/app/shared/app-profile/app-profile';
import { LoaderService } from 'src/app/core/services/loader.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CareTeamService } from 'src/app/core/services/care-team.service';
import { SearchResult } from '../patient-management-system/patient-management-system.component';
import { AccessoryService } from 'src/app/core/services/accessory.service';

export class Patient {
  public id: number;
  public name: string;
  public gender: string;l̥
  public dob: string;
  public birthDate?: string;
  public age: string;
  public patientRef: string;
  public patientExternalId: string;
  public patnr: string;
  public email: string;
  public services: string;
  public primaryproblem: string;
  public address: string;
  public location: string;
  public setupDate: string;
  public careTeam: string;
  public serialNumber: string;
  public lastUsageDate: string;
  public usage: string;
  daysUsed: string;
  avgHoursPerDay: string;
  usagePercentage: string;
  deviceCategory: string;
  accessoriesHidden: boolean = false;
  extension?: { url: string; valueDateTime?: string }[];

  public constructor(id?: number) {
      this.id = id;
      this.name = '';
      this.dob = '';
      this.gender = '';
      this.patientRef = '';
      this.patientExternalId = '';
      this.patnr = '';
      this.email = '';
      this.services = '';
      this.primaryproblem = '';
      this.address = ''
      this.location = ''
      this.setupDate = ''
      this.careTeam = ''
      this.serialNumber = ''
      this.lastUsageDate = ''
      this.daysUsed = ''
      this.avgHoursPerDay = ''
      this.usagePercentage = ''
      this.deviceCategory = ''
  }
}
@Component({
  selector: 'app-patient-management-system-aggregator',
  templateUrl: '../patient-search-shared.html',
  styleUrl: '../patient-search-shared.scss'
})

export class PatientManagementSystemAggregatorComponent implements OnInit {
  showMoreOptions = false;
  hover: boolean = false;
  selectedStatus: 'Active' | 'Inactive' | 'All' = 'Active';
  selectedSort: string = 'setup';
  sortDirection: 'asc' | 'desc' = 'desc';
  patients: Patient[] = [];
  patientLoading: { [id: string]: boolean } = {};
  showAddPatientModal = false;
  selectedPatient: Patient | null = null;
  today = new Date().toISOString().substring(0, 10);
  patientTabs = ['Identity', 'Contact information', 'Care team', 'Equipment', 'Rules and reminders'];
  activeTab = 0;
  patientCreated = false;
  identityForm: FormGroup;
  careTeamMembers: any[] = [{ role: '', user: '' }];
  careTeamForm: FormGroup;
  contactForm: FormGroup;
  rulesForm: FormGroup;
  users: any[] = [
    { id: '1', name: 'PMS User' },
    { id: '2', name: 'Pooja DME' },
    { id: '3', name: 'Pooja Sub Dme' },
    // Add more users as needed
  ];
  notification: { show: boolean; message: string; type: 'success' | 'error' } = { show: false, message: '', type: 'success' };
  ruleSets: any[] = [];
  selectedRuleSetId: string = '';
  // searchResults: any[] = [];
  // private searchTerms = new Subject<string>();
  searchTerm: string = '';
    // Multiple search type options (checkboxes). Empty array = unselected on initial load
    patientSearchTypes: string[] = [];
    searchResults: SearchResult[] = []; // Use the imported interface for type safety
    private searchSubject = new Subject<string>();
    isLoadings: boolean = false;
    errorMessage: string = '';
   selectedDevice = {
    device: '',
    serialNumber: '',
    assignmentDate: '',
    dataSource: '',
    id:''
  };
  selectedConnectivity = {
    type: '',
    provider: '',
    identifier: '',
    assignmentDate: '',
    resupplyDate: ''
  };
  selectedAccessory = {
  type: '',
  model: '',
  detail: '',
  assignmentDate: '',
  resupplyDate: ''
};

  devicesHidden: boolean = true;
  connectivityHidden: boolean = true;
  accessoriesHidden: boolean = true;
  savedDevices: any[] = [];
  savedConnectivity: any[] = [];
  savedAccessories: any[] = [];

   accessoryOptions: { [key: string]: { models: string[]; details: string[] } } = {
    Cushion: {
      models: ['Amara Cushion', 'Amara Gel Cushion', 'ComfortGel Cushion', 'DreamWear Cushion', 'DreamWear Full Cushion', 'DreamWear Gel Cushion'],
      details: ['Petite', 'Small', 'Medium', 'Large']
    },
    Headgear: {
      models: ['Amara Headgear', 'Amara View Headgear', 'DreamWear Frame', 'DreamWear Full Headgear', 'DreamWear Headgear'],
      details: ['Petite', 'Small', 'Medium', 'Large']
    },
    Mask: {
      models: ['Amara Silicone', 'Amara View', 'Comfort Classic', 'Comfort Full', 'Comfort Fusion'],
      details: ['Extra Small', 'Small', 'Medium', 'Large', 'Extra Large']
    },
    'Breathing Circuit': {
      models: ['Active', 'Adapter', 'Passive'],
      details: ['Adult with heated wire', 'Pediatric with heated wire', 'Peadiatric with water trap']
    }
  };

   get accessoryTypes(): string[] {
    return Object.keys(this.accessoryOptions);
  }

  get models(): string[] {
    return this.selectedAccessory.type ? this.accessoryOptions[this.selectedAccessory.type]?.models || [] : [];
  }

  get details(): string[] {
    return this.selectedAccessory.type ? this.accessoryOptions[this.selectedAccessory.type]?.details || [] : [];
  }


  constructor(
    private http: HttpClient,
    private appProfile: AppProfile,
    private authService: AuthService,
    public loaderService: LoaderService,
    private fb: FormBuilder,
    private careTeamService: CareTeamService,
    private accessoryService: AccessoryService
  ) {
    this.loaderService.show();
    this.identityForm = this.fb.group({
      location: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      dob: ['', Validators.required],
      gender: ['', Validators.required],
      setupDate: ['', Validators.required],
      patientExternalId: [''],
      patientReference: [''],
      payer: [''],
      secondaryPayer: [''],
      payerMemberId: [''],
      secondaryPayerMemberId: ['']
    });
    this.searchSubject.pipe(
          debounceTime(300), // Wait for 300ms after the last keystroke
          distinctUntilChanged(), // Only emit if the value has changed
          switchMap((term: string) => {
            this.isLoadings = true; // Set loading state
            this.errorMessage = ''; // Clear previous errors
            return this.careTeamService.searchByName(term).pipe(
              catchError(error => {
                console.error('Search API error:', error);
                this.errorMessage = 'Failed to fetch search results. Please try again.';
                this.isLoadings = false;
                return of([]); // Return an empty array on error to prevent breaking the stream
              })
            );
          })
        ).subscribe(results => {
          this.searchResults = results;
          this.isLoadings = false; // Clear loading state
        });
  }

  ngOnInit(): void {
     const token = this.authService.accessToken;
    console.log('Access Token:', token);
    this.callAggregator();
    this.careTeamForm = this.fb.group({
      role0: ['clinician'],
      user0: ['1']
    });
    this.contactForm = this.fb.group({
      phoneNumber: [''],
      preferredNumber: [false],
      email: [''],
      preferredContactMethod: [''],
      streetAddress: [''],
      postalCode: [''],
      city: [''],
      state: [''],
      country: ['India'],
      timeZone: ['', Validators.required],
      startTime: ['12:00']
    });
    this.rulesForm = this.fb.group({
      complianceRule: ['rule1'],
      ruleSet: ['company'],
      reminderSet: [['company']]
    });
    this.fetchRuleSets();
  }

  onSearchChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.searchTerm = inputElement.value;
    this.searchSubject.next(this.searchTerm);
  }

  private getCommonHeaders(token: string): HttpHeaders {
    return new HttpHeaders({
      'X-tenant-Id': '2faca8f1-c381-4122-a634-471e1075dd8d',
      'Content-Type': 'application/json',
      'org': '2faca8f1-c381-4122-a634-471e1075dd8d',
      'api-version': '1.0.0',
      'auth-token': `${token}`
    });
  }

  fetchRuleSets() {
    const headers = this.getCommonHeaders(this.authService.token).set('api-version', '2.0.0');
    const orgId = this.getCommonHeaders(this.authService.token).get('org');
    this.http.get<any>(`${this.appProfile.ampmUs}/pes/fhir/${orgId}/RuleSet`, { headers }).subscribe(res => {
      if (res && res.entry) {
        this.ruleSets = res.entry.map((e: any) => ({
          id: e.resource.id,
          title: e.resource.title || e.resource.name || 'Untitled',
          status: e.resource.status,
          rules: ''
        }));
        if (this.ruleSets.length > 0) {
          this.selectedRuleSetId = this.ruleSets[0].id;
        }
      }
    });
  }

  callAggregator() {
    const url = `${this.appProfile.epUs}/pws/Patient/patient-search`;
    const token = this.authService.token;
    // On initial load we do NOT pass patient-search-type header (should be unselected by default)
    const headers = this.getCommonHeaders(token).set('search-type', 'SEARCH');
    const body = { active: true };
    this.http.post<any>(url, body, { headers }).subscribe({
      next: (response) => {
        this.loaderService.hide();
        // Map response to this.patients as Patient[]
        this.patients = (response?.patientSearchDataList || []).map((item: any) => {
          const patient = new Patient(item.id);
          // Combine first name and family name from FHIR-style resource when available, otherwise fall back to firstName/lastName or 'Unknown'
          if (Array.isArray(item.name) && item.name.length > 0) {
            patient.name = `${item.name[0].given?.join(' ') || ''} ${item.name[0].family || ''}`.trim() || 'Unknown';
          } else if (item.firstName || item.lastName) {
            patient.name = `${item.firstName || ''} ${item.lastName || ''}`.trim() || 'Unknown';
          } else if (Array.isArray(item.entry) && item.entry.length > 0 && Array.isArray(item.entry[0].resource?.name) && item.entry[0].resource.name.length > 0) {
            // Handle nested FHIR bundle entry
            const entry = item.entry[0];
            patient.name = Array.isArray(entry.resource.name) && entry.resource.name.length > 0
              ? `${entry.resource.name[0].given?.join(' ') || ''} ${entry.resource.name[0].family || ''}`.trim()
              : 'Unknown';
          } else {
            patient.name = 'Unknown';
          }
          patient.dob = this.parseDate(item.dateOfBirth);
          patient.setupDate = this.parseDate(item.setupDate);
          patient.serialNumber = item.serialNumber || '';
          patient.deviceCategory = item.deviceCategory || '';
          patient.lastUsageDate = this.parseDate(item.lastUsageDate);
          patient.usagePercentage = item.usagePercentage || '';
          patient.careTeam = item.careTeam || '';
          patient.address = item.address || '';
          patient.location = item.location || '';
          patient.patientRef = item.patientReference || '';
          return patient;
        });
      },
      error: (err) => {
        this.loaderService.hide();
        console.error('Failed to fetch patients:', err);
      }
    });
  }

  toggleOptions(event: Event) {
    event.preventDefault();
    this.showMoreOptions = !this.showMoreOptions;
  }

  togglePatientSearchType(type: string, checked: boolean) {
    if (checked) {
      if (!this.patientSearchTypes.includes(type)) this.patientSearchTypes.push(type);
    } else {
      this.patientSearchTypes = this.patientSearchTypes.filter(t => t !== type);
    }
  }

  toggleSortDirection() {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    // Add sorting logic here
  }

  sortPatients(criteria: string): void {
    if (criteria === 'name') {
      this.patients.sort((a, b) => a.name.localeCompare(b.name));
    } else if (criteria === 'dob') {
      this.patients.sort((a, b) => new Date(a.dob).getTime() - new Date(b.dob).getTime());
    } else if (criteria === 'setupDate') {
      this.patients.sort((a, b) => new Date(a.setupDate).getTime() - new Date(b.setupDate).getTime());
    }
  }

  filterStatus(status: 'Active' | 'Inactive' | 'All') {
    this.selectedStatus = status;
    // Add filtering logic here
  }

   onAccessoryChange() {}

   onModelChange() {}

    resetForm() {}

    saveAccessory() {}

    editAccessory(index: number) {}

    deleteAccessory(index: number) {}

    saveDevice() {}

    editDevice(index: number) {}

    deleteDevice(index: number,  deviceId: string) {}

    saveConnectivity() {}

    editConnectivity(index: number) {}

    deleteConnectivity(index: number) {}

  private parseDate(dateStr: string): string {
    if (!dateStr) return '';
    // Handle FHIR DateTimeType[2025-02-28T17:39:55+00:00] or similar
    const match = dateStr.match(/\[(.*?)\]/);
    if (match && match[1]) return match[1];
    // Handle Sat Dec 23 00:00:00 GMT 1989 or similar
    const date = new Date(dateStr);
    return isNaN(date.getTime()) ? dateStr : date.toISOString();
  }

  get isLoading() {
    return this.loaderService.loading$;
  }

  openPatientCarePlan(patient: Patient) {
    this.selectedPatient = patient;
  }

  createPatient() {
    if (this.identityForm.valid) {
      // Call your API to create the patient here
      // On success:
      this.patientCreated = true;
      this.activeTab = 1; // Move to next tab
    } else {
      this.identityForm.markAllAsTouched();
    }
  }

  closeAddPatientModal() {
    this.showAddPatientModal = false;
    this.activeTab = 0;
    this.patientCreated = false;
    this.identityForm.reset();
  }

  clearLocation() {
    this.identityForm.get('location')?.setValue('');
  }

  onCancel() {
    this.closeAddPatientModal();
  }

  onSave() {
    this.createPatient();
  }

  addCareTeamMember() {
    const idx = this.careTeamMembers.length;
    this.careTeamMembers.push({ role: '', user: '' });
    this.careTeamForm.addControl('role' + idx, this.fb.control('clinician'));
    this.careTeamForm.addControl('user' + idx, this.fb.control('1'));
  }

  removeCareTeamMember(i: number) {
    this.careTeamMembers.splice(i, 1);
    this.careTeamForm.removeControl('role' + i);
    this.careTeamForm.removeControl('user' + i);
  }

  private getOrderedPatientSearchTypes(types: string[] = []): string[] {
    const order = ['exact', 'partial', 'fuzzy'];
    return order.filter(t => types.includes(t));
  }

  async searchPatients(name: string, dob: string, postal: string, phone: string, searchTypes: string[] = []) {
    const url = `${this.appProfile.epUs}/pws/Patient/patient-search`;
    const token = this.authService.token;
    let headers = this.getCommonHeaders(token).set('search-type', 'SEARCH');
    // Only add patient-search-type header when user has selected one or more options
    const ordered = this.getOrderedPatientSearchTypes(searchTypes);
    if (ordered.length > 0) {
      headers = headers.set('patient-search-type', ordered.join(','));
    }
    const body: any = { active: true };
    if (name) body.given = name;
    if (dob) body.dateOfBirth = dob;
    if (postal) body.postalCode = postal;
    if (phone) body.phone = phone;

    this.loaderService.show();
    this.http.post<any>(url, body, { headers }).subscribe({
      next: (response) => {
        this.loaderService.hide();
        this.patients = (response?.patientSearchDataList || []).map((item: any) => {
          const patient = new Patient(item.id);
          if (Array.isArray(item.name) && item.name.length > 0) {
            patient.name = `${item.name[0].given?.join(' ') || ''} ${item.name[0].family || ''}`.trim() || 'Unknown';
          } else if (item.firstName || item.lastName) {
            patient.name = `${item.firstName || ''} ${item.lastName || ''}`.trim() || 'Unknown';
          } else if (Array.isArray(item.entry) && item.entry.length > 0 && Array.isArray(item.entry[0].resource?.name) && item.entry[0].resource.name.length > 0) {
            const entry = item.entry[0];
            patient.name = Array.isArray(entry.resource.name) && entry.resource.name.length > 0
              ? `${entry.resource.name[0].given?.join(' ') || ''} ${entry.resource.name[0].family || ''}`.trim()
              : 'Unknown';
          } else {
            patient.name = 'Unknown';
          }
          patient.dob = this.parseDate(item.dateOfBirth);
          patient.setupDate = this.parseDate(item.setupDate);
          patient.serialNumber = item.serialNumber || '';
          patient.deviceCategory = item.deviceCategory || '';
          patient.lastUsageDate = this.parseDate(item.lastUsageDate);
          patient.usagePercentage = item.usagePercentage || '';
          patient.careTeam = item.careTeam || '';
          patient.address = item.address || '';
          patient.location = item.location || '';
          patient.patientRef = item.patientReference || '';
          return patient;
        });
        // Clear any error notification on success
        this.notification.show = false;
      },
      error: (err) => {
        this.loaderService.hide();
        this.patients = []; // Clear patient list on error
        console.error('Failed to search patients:', err);

        // Extract and display error message
        let errorMsg = 'Failed to search patients. Please try again.';
        if (err?.status === 400) {
          // Try to extract validation error message
          if (err?.error?.validationErrors && Array.isArray(err.error.validationErrors) && err.error.validationErrors.length > 0) {
            const validationError = err.error.validationErrors[0];
            if (validationError?.errorMessage) {
              // Extract the actual error message from nested string
              const match = validationError.errorMessage.match(/errorMessage=(.+?)\)/);
              errorMsg = match ? match[1] : validationError.errorMessage;
            }
          } else {
            errorMsg = err?.error?.message || 'Bad Request. Please check your search criteria.';
          }
        } else if (err?.status === 401) {
          errorMsg = 'Unauthorized. Please log in again.';
        } else if (err?.status === 403) {
          errorMsg = 'Access Denied. You do not have permission to search patients.';
        } else if (err?.status === 404) {
          errorMsg = 'No patients found matching your criteria.';
        } else if (err?.status === 500) {
          errorMsg = err?.error?.message || 'Server Error. Please contact support.';
        } else if (err?.message) {
          errorMsg = err.message;
        }

        this.notification = {
          show: true,
          message: errorMsg,
          type: 'error'
        };
        // Auto-hide notification after 5 seconds
        setTimeout(() => { this.notification.show = false; }, 5000);
      }
    });
  }

  createAccessory() { }

  onOptionSelected(event: Event): void {}

  getCushionPayload() {}

  getBreathingCircuitPayload() {}

  toggleForm() {}


    goToPreviousTab() {
    if (this.activeTab > 0) this.activeTab--;
  }

  skipCurrentTab() {
    if (this.activeTab < 4) this.activeTab++;
  }

  skipAllTabs() {
    this.activeTab = 4;
  }

  isCurrentFormValid(): boolean {
    switch (this.activeTab) {
      case 0: return this.identityForm.valid;
      case 1: return this.contactForm.valid;
      case 2: return this.careTeamForm.valid;
      case 3: return true; // Add validation if needed
      case 4: return true; // Add validation if needed
      default: return true;
    }
  }

  saveCurrentTab() {
    switch (this.activeTab) {
      case 0:
        this.createPatient();
        break;
      case 1:
        // Save contact info logic here
        this.skipCurrentTab();
        break;
      case 2:
        // Save care team logic here
        this.skipCurrentTab();
        break;
      case 3:
        // Save equipment logic here
        this.skipCurrentTab();
        break;
      case 4:
        // Save rules/reminders logic here
        this.showAddPatientModal = false;
        break;
      default:
        break;
    }
  }

}
